export class ActionIconHelper {
  static getActionIconUrl(actionName: string, dark = true, notExt: boolean = false): string {
    let icon = '';

    switch (actionName) {
      case 'LEAD_PROCESS_EXT':
        icon = dark ? 'assets/icons/new/checkmark.svg' : 'assets/icons/new/checkmark-light.svg';
        break;
      case 'LEAD_FORWARD':
        icon = dark ? 'assets/icons/new/send.svg' : 'assets/icons/new/send-light.svg';
        break;
      case 'APPOINTMENT_REMINDER':
      case 'LEAD_REMINDER':
        icon = dark ? 'assets/icons/new/pause.svg' : 'assets/icons/new/pause-light.svg';
        break;
      case 'LEAD_PROCESS':
        icon = dark ? 'assets/icons/new/checkmark.svg' : 'assets/icons/new/checkmark-light.svg';
        break;
      case 'FILE_COPY':
        icon = dark ? 'assets/icons/file-copy.svg' : 'assets/icons/file-copy.svg';
        break;
      case 'ORDER_PLACED':
        icon = dark ? 'assets/icons/new/parcel.svg' : 'assets/icons/new/parcel-light.svg';
        break;
      case 'ORDER_PLACED_EXTERNAL':
        if (notExt) {
          icon = dark ? 'assets/icons/new/parcel.svg' : 'assets/icons/new/parcel-light.svg';
        } else {
          icon = dark ? 'assets/icons/new/parcel.svg' : 'assets/icons/new/parcel-light.svg';
        }
        break;
      case 'LEAD_FORWARD_EXT':
        icon = dark ? 'assets/icons/new/send.svg' : 'assets/icons/new/send-light.svg';
        break;
      case 'LEAD_FORWARD_CONFIRM':
        icon = dark ? 'assets/icons/new/persons.svg' : 'assets/icons/new/persons-light.svg';
        break;
      case 'LEAD_REMINDER_EXT':
        icon = dark ? 'assets/icons/new/communicate.svg' : 'assets/icons/new/communicate-light.svg';
        break;
      case 'OFFER_DELAY':
        icon = dark ? 'assets/icons/new/pause.svg' : 'assets/icons/new/pause-light.svg';
        break;
      case 'LEAD_REJECT':
        icon = dark ? 'assets/icons/new/close.svg' : 'assets/icons/new/close-light.svg';
        break;
      case 'LEAD_CONNECT':
        icon = dark ? 'assets/icons/new/link.svg' : 'assets/icons/new/link-light.svg';
        break;
      case 'LEAD_FORWARD_UNDO':
        icon = dark ? 'assets/icons/new/persons.svg' : 'assets/icons/new/persons-light.svg';
        break;
      case 'LEAD_TYPE':
        icon = dark ? 'assets/icons/new/edit.svg' : 'assets/icons/new/edit-light.svg';
        break;
      case 'LEAD_NOT_INTERESTED':
        icon = dark ? 'assets/icons/new/trash-close.svg' : 'assets/icons/new/trash-close-light.svg';
        break;
      case 'APPOINTMENT_MOVE':
        icon = dark ? 'assets/icons/new/time.svg' : 'assets/icons/new/time-light.svg';
        break;
      case 'OFFER_MOVE':
        icon = dark ? 'assets/icons/new/time.svg' : 'assets/icons/new/time-light.svg';
        break;
      case 'OFFER_SUBMIT':
        icon = dark ? 'assets/icons/new/file.svg' : 'assets/icons/new/file-light.svg';
        break;
      case 'OFFER_SUBMIT_EXTERNAL':
        if (notExt) {
          icon = dark ? 'assets/icons/new/file.svg' : 'assets/icons/new/file-light.svg';
        } else {
          icon = dark ? 'assets/icons/new/file.svg' : 'assets/icons/new/file-light.svg';
        }
        break;
      case 'APPOINTMENT_CREATE':
        icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        break;
      case 'APPOINTMENT_CREATE_EXTERNAL':
        if (notExt) {
          icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        } else {
          icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        }
        break;
      case 'CONSULTATION_CREATE':
        icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        break;
      case 'CONSULTATION_CREATE_EXTERNAL':
        if (notExt) {
          icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        } else {
          icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        }
        break;
      case 'DUPLICATE_CHECK':
        icon = dark ? 'assets/icons/duplicate.svg' : 'assets/icons/duplicate.svg';
        break;
      case 'NEW-EMAIL':
        icon = dark ? 'assets/icons/save-dark.svg' : 'assets/icons/save-blue.svg';
        break;
      case 'NEGOTIATION_CREATE':
        icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        break;
      case 'NEGOTIATION_MOVE':
        icon = dark ? 'assets/icons/new/calendar-day.svg' : 'assets/icons/new/calendar-day-light.svg';
        break;
      case 'LEAD_REOPEN':
        icon = dark ? 'assets/icons/new/retry.svg' : 'assets/icons/new/retry-light.svg';
        break;
      case 'LEAD_TAKEOVER':
        icon = dark ? 'assets/icons/new/persons.svg' : 'assets/icons/new/persons-light.svg';
        break;
      case 'LEAD_STATUS':
        icon = dark ? 'assets/icons/edit-blue.svg' : 'assets/icons/edit-blue.svg';
        break;
      case 'COMPENDIUM_DENY':
        icon = dark ? 'assets/icons/new/cancel.svg' : 'assets/icons/new/cancel-light.svg';
        break;
      case 'COMPENDIUM_DENIED':
        icon = dark ? 'assets/icons/new/cancel.svg' : 'assets/icons/new/cancel-light.svg';
        break;
      case 'COMPENDIUM_ALLOW':
        icon = dark ? 'assets/icons/new/book-2.svg' : 'assets/icons/new/book-2-light.svg';
        break;
      case 'COMPENDIUM_SEND':
        icon = dark ? 'assets/icons/new/book-2.svg' : 'assets/icons/new/book-2-light.svg';
        break;
      case 'COMPENDIUM_REQUEST':
        icon = dark ? 'assets/icons/new/book-2.svg' : 'assets/icons/new/book-2-light.svg';
        break;
      case 'LEAD_BROKER_START':
      case 'LEAD_BROKER_SEND_WAVE':
        icon = dark ? 'assets/icons/new/double-arrow.svg' : 'assets/icons/new/double-arrow-light.svg';
        break;
      case 'LEAD_BROKER_TAKEOVER':
      case 'LEAD_BROKER_LEAD_ACCEPTED':
        icon = dark ? 'assets/icons/new/persons.svg' : 'assets/icons/new/persons-light.svg';
        break;
      case 'LEAD_BROKER_ABORT':
        icon = dark ? 'assets/icons/new/cancel.svg' : 'assets/icons/new/cancel-light.svg';
        break;
      case 'LEAD_BROKER_SUCCESS':
        icon = dark ? 'assets/icons/new/checkmark.svg' : 'assets/icons/new/checkmark-light.svg';
        break;
      case 'PLANNER_VISIT':
      case 'PLANNER_VISIT_MOVE':
      case 'PLANNER_VISIT_EXT':
        icon = dark ? 'assets/icons/new/marker.svg' : 'assets/icons/new/marker-light.svg';
        break;
      case 'PLANNER_INVITE':
      case 'PLANNER_INVITE_MOVE':
      case 'PLANNER_INVITE_EXT':
        icon = dark ? 'assets/icons/new/calendar.svg' : 'assets/icons/new/calendar-light.svg';
        break;
      default:
        icon = dark ? 'assets/icons/file-calendar-dark.svg' : 'assets/icons/file-calendar.svg';
        break;
    }

    return icon;
  }

  static getActionClassName(actionName: string): string {

    switch (actionName) {
      case 'LEAD_PROCESS_EXT':
        return 'lead-process-ext';
      case 'LEAD_FORWARD':
        return 'lead-forward';
      case 'LEAD_REOPEN':
        return 'lead-reopen';
      case 'APPOINTMENT_REMINDER':
        return 'appointment-reminder';
      case 'LEAD_REMINDER':
        return 'lead-reminder';
      case 'LEAD_PROCESS':
        return 'lead-process';
      case 'ORDER_PLACED':
        return 'order-placed';
      case 'ORDER_PLACED_EXTERNAL':
        return 'order-placed-ext';
      case 'LEAD_FORWARD_EXT':
        return 'lead-forward-ext'
      case 'OFFER_DELAY':
        return 'offer-delay';
      case 'LEAD_REJECT':
        return 'lead-reject';
      case 'LEAD_FORWARD_UNDO':
        return 'lead-forward-undo';
      case 'LEAD_TYPE':
        return 'lead-type';
      case 'LEAD_NOT_INTERESTED':
        return 'lead-not-interested';
      case 'APPOINTMENT_MOVE':
        return 'appointment-move';
      case 'OFFER_MOVE':
        return 'offer-move';
      case 'OFFER_SUBMIT':
        return 'offer-submit';
      case 'OFFER_SUBMIT_EXTERNAL':
        return 'offer-submit-ext';
      case 'APPOINTMENT_CREATE':
        return 'appointment-create';
      case 'APPOINTMENT_CREATE_EXTERNAL':
        return 'appointment-create-ext';
      case 'CONSULTATION_CREATE':
        return 'consultation-create';
      case 'CONSULTATION_CREATE_EXTERNAL':
        return 'consultation-create-ext';
      case 'NEGOTIATION_CREATE':
        return 'negotiation-create';
      case 'NEGOTIATION_MOVE':
        return 'negotiation-move';
      default:
        return 'appointment-create';
    }
  }

}
